// components/assignmentTexts/index.js
import {makeAssType_1} from "./assType_1";
import {makeAssType_2} from "./assType_2";
import {makeAssType_3} from "./assType_3";
import {makeAssType_4} from "./assType_4";
import {makeAssType_5} from "./assType_5";
import {makeAssType_6} from "./assType_6";
import {makeAssType_7} from "./assType_7";
import {makeAssType_8} from "./assType_8";
import {makeAssType_9} from "./assType_9";
import {makeAssType_10} from "./assType_10";
import {makeAssType_11} from "./assType_11";
import {makeAssType_12} from "./assType_12";
import {makeAssType_13} from "./assType_13";
import {makeAssType_14} from "./assType_14";
import {makeAssType_15} from "./assType_15";
import {makeAssType_16} from "./assType_16";
import {makeAssType_17} from "./assType_17";
import {makeAssType_18} from "./assType_18";
import {makeAssType_19} from "./assType_19";
import {makeAssType_20} from "./assType_20";
import {makeAssType_21} from "./assType_21";
import {makeAssType_22} from "./assType_22";
import {makeAssType_23} from "./assType_23";
import {makeAssType_24} from "./assType_24";
import {makeAssType_25} from "./assType_25";
import {makeAssType_26} from "./assType_26";
import {makeAssType_27} from "./assType_27";
import {makeAssType_28} from "./assType_28";
import {makeAssType_29} from "./assType_29";
import {makeAssType_30} from "./assType_30";
import {makeAssType_31} from "./assType_31";
import {makeAssType_32} from "./assType_32";

// …добавляй по мере необходимости

export const buildAssignmentTexts = (deps) => ({
    1: makeAssType_1(deps),
    2: makeAssType_2(deps),
    3: makeAssType_3(deps),
    4: makeAssType_4(deps),
    5: makeAssType_5(deps),
    6: makeAssType_6(deps),
    7: makeAssType_7(deps),
    8: makeAssType_8(deps),
    9: makeAssType_9(deps),
    10: makeAssType_10(deps),
    11: makeAssType_11(deps),
    12: makeAssType_12(deps),
    13: makeAssType_13(deps),
    14: makeAssType_14(deps),
    15: makeAssType_15(deps),
    16: makeAssType_16(deps),
    17: makeAssType_17(deps),
    18: makeAssType_18(deps),
    19: makeAssType_19(deps),
    20: makeAssType_20(deps),
    21: makeAssType_21(deps),
    22: makeAssType_22(deps),
    23: makeAssType_23(deps),
    24: makeAssType_24(deps),
    25: makeAssType_25(deps),
    26: makeAssType_26(deps),
    27: makeAssType_27(deps),
    28: makeAssType_28(deps),
    29: makeAssType_29(deps),
    30: makeAssType_30(deps),
    31: makeAssType_31(deps),
    32: makeAssType_32(deps),

});
